import { SAAS_ELITE_ORGANIZATION_STATUS } from "@/core/enums/SAAS_ELITE_ORGANIZATION_STATUS";

export const ORGANIZATION_API_PATH = {
  GET: "v1/organization/",
  POST: "v1/organization/",
  PATCH: "v1/organization/",
  DELETE: "v1/organization",
  GET_BY_ID: "v1/organization/",
  ADD_AGENT_IN_ORGANIZATION:
    "organization-user/{0}/create-update-organization-user/",
  VALIDATE_BULK_ORGANIZATION_USERS:
    "organization-user/{0}/users/bulk/validate/",
  IMPORT_BULK_ORGANIZATION_USERS: "organization-user/{0}/users/bulk/import/",
  GET_ORGANIZATION_AGENT_BY_ID: "v1/organization/{0}/organization-user/{1}/",
  GET_ORGANIZATION_USERS: "v1/organization/{0}/organization-user/",
  ORGANIZATION_FORM: "v1/organization/creation-form/",
  WEBSITE_CONFIGURATION: "v1/organization/{0}/website/",
  WEBSITE_CONTENT: "v1/organization/{0}/website/content/",
  WEBSITE_CONTENT_UPDATE: "v1/organization/{0}/website/content/update/",
  DELETE_ORGANIZATION_PASSENGERS: "v1/organization/{0}/passengers",
  GET_ORGANIZATION_PASSENGERS: "v1/organization/{0}/passengers/",
  GET_TRAVELER_PROFILES: "v3/organization/{0}/list/passengers/",
  GET_ORGANIZATION_PASSENGERS_BY_ID: "v1/organization/{0}/passenger/",
  GET_ORGANIZATION_PASSENGER_SETUP_FORM:
    "v1/organization/{0}/passenger-form-setup/",
  GET_ORGANIZATION_PASSENGER_SETUP_FORM_V2:
    "v2/organization/{0}/passenger-form-setup/",
  POST_ORGANIZATION_PASSENGERS: "v2/organization/{0}/passengers/",
  UPDATE_ORGANIZATION_PASSENGERS: "v2/organization/{0}/passengers/",
  CONTENT_UPLOAD: "v1/content/upload/{0}/",
  CONFIG_UPDATE: "v1/organization/{0}/config/",
  ORGANIZATION_SNAPSHOT: "v1/insights/organization/{0}/usage-snapshot/",
  ORGANIZATION_PRODUCTIVITY:
    "v1/insights/organization/{0}/productivity-snapshot/",
  CURRENCIES: "v1/currency/",
  SAAS_ELITE_ORGANIZATION: "v1/organization/saas-elite-organization/",
  UPDATE_ELITE_ORGANIZATION_STATUS: "v1/organization/{0}/update-status/",
  GET_INTERNAL_PROVIDERS: "v1/flights/get-internal-providers/",
  UPDATE_INTERNAL_PROVIDERS: "v1/financial-profile/financial-profile-update/",
  GET_PRICING_LIST: "v1/financial-profile/{0}/pricing-list/",
  GET_PRICING_CREATION_FORM: "v1/financial-profile/pricing-creation-form/",
  CREATE_PRICING: "v1/financial-profile/{0}/pricing-create-and-update/",
  UPDATE_PRICING: "v1/financial-profile/{0}/pricing-create-and-update/ ",
};

export const ORGANIZATION_COLORS = [
  {
    code: "#10B981",
    name: "Cyan green",
  },
  {
    code: "#000000",
    name: "Black",
  },
  {
    code: "#014B4C",
    name: "Teal",
  },
  {
    code: "#022E1F",
    name: "Green",
  },
  {
    code: "#595B00",
    name: "Olive",
  },
  {
    code: "#9A8872",
    name: "Beige",
  },
  {
    code: "#E87F78",
    name: "Peach",
  },
  {
    code: "#870000",
    name: "Red",
  },
  {
    code: "#5B002B",
    name: "Maroon",
  },
  {
    code: "#820FC0",
    name: "Purple",
  },
  {
    code: "#073ee3",
    name: "Royal Blue",
  },
  {
    code: "#122949",
    name: "Dark Blue",
  },
  {
    code: "#986A33",
    name: "Brown",
  },
  {
    code: "#EFB701",
    name: "Yellow",
  },
  {
    code: "#D54B01",
    name: "Orange",
  },
];

export const PIA_PROVIDERS = [
  {
    label: "Quality Aviation",
    value: "QualityAviation",
  },
  {
    label: "Quality Aviation - Lite",
    value: "QA_LITE",
  },
  { label: "Soneri - Lite", value: "AG_LITE_RWP" },
  {
    label: "Soneri",
    value: "Soneri",
  },
  {
    label: "Fleet Aviation",
    value: "AG_LHE_FA",
  },
  {
    label: "Fleet Aviation - Lite",
    value: "AG_LHE_FA_LITE",
  },
];

export const CATEGORIES = [
  "Travel Agent",
  "Staff Individuals Account",
  "Corporate CWT Referred",
  "Local Corporate Clients",
  "Vox Labs",
  "Sasta Ticket Account",
];

export const WHATSAPP_MEMBERS_PAGE_SIZE = 10;

export const WHATSAPP_API_PATH = {
  GET: "v1/organization/{0}/whatsapp-whitelist-numbers/",
  POST: "v1/organization/{0}/whatsapp-whitelist-numbers/",
  GENERATE_OTP:
    "v1/organization/{0}/whatsapp-whitelist-number/{1}/generate-otp/",
  AUTHORIZE_OTP:
    "v1/organization/{0}/whatsapp-whitelist-number/{1}/authorize-contact-number/",
  DELETE_WHATSAPP: "v1/organization/{0}/whatsapp-whitelist-numbers",
};

export enum ORGANIZATION_STATUS {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}

export const ORGANIZATION_STATUS_MAPPING = {
  INACTIVE: "gray",
  ACTIVE: "green",
};

export enum SAAS_ORGANIZATION_STATUSES {
  DOCUMENTS_PENDING = "DOCUMENTS_PENDING",
  FINANCIAL_PROFILE_PENDING = "FINANCIAL_PROFILE_PENDING",
  VERIFIED = "VERIFIED",
}

export enum SAAS_ORGANIZATION_DOCUMENTS_STATUSES {
  REJECT = "REJECT",
  APPROVE = "APPROVE",
}

export const SAAS_ORGANIZATION_STATUSES_MAPPING = {
  [SAAS_ELITE_ORGANIZATION_STATUS.DOCUMENTS_PENDING]: "info",
  [SAAS_ELITE_ORGANIZATION_STATUS.FINANCIAL_PROFILE_PENDING]: "warning",
  [SAAS_ELITE_ORGANIZATION_STATUS.FINANCIAL_PROFILE_ATTACHED]: "warning",
  [SAAS_ELITE_ORGANIZATION_STATUS.VERIFIED]: "success",
} as const;
